import * as z from 'zod';
import * as ba from './base';
import { SCRIPT_SCHEMA } from '../scripting';
import { CRUD } from '../connections';
import { assertComponentContext } from '../helpers';

export interface CRUDActionArgs {
  objectType: string;
  op: 'upsert' | 'delete';
  data?: any;
  options?: any;
}

export class CRUDAction extends ba.Action<CRUDActionArgs, any> {
  static get manifest() {
    return {
      name: 'crud',
      schema: z.object({
        objectType: z.string(),
        op: z.union([z.literal('upsert'), z.literal('delete')]),
        data: z.any().optional(),
        options: z.record(z.string(), z.any()).optional()
      })
    };
  }

  async handle(event: ba.ActionEvent, args: CRUDActionArgs) {
    assertComponentContext(event.component);
    const obj = CRUD.createCRUD(args.objectType, event.component.$app);
    const meth = args.op === 'delete' ? obj.delete : obj.upsert;

    await this.dispatch('before', {});

    const response = await meth.call(obj, args.data, args.options);
    await this.dispatch('success', response);
    return response;

    // try {
    // } catch (error) {
    //   await this.dispatch('error', { error });
    // }
  }
}
